import forEach from '../../../../javascripts/dom/forEach';

const messestandElements = document.querySelectorAll('.o-messestandpreise');

forEach(messestandElements, (index, element) => {
  if (element) {
    require.ensure(
      [],
      require => {
        const PhotoSwipe = require('photoswipe');
        const PhotoSwipeUiDefault = require('photoswipe/dist/photoswipe-ui-default');
        const { MessestandpreiseCarousel } = require('./messestand');
        
        // Prevent double initialization
        if (!element.dataset.initialized) {
          new MessestandpreiseCarousel(element, PhotoSwipe, PhotoSwipeUiDefault);
          element.dataset.initialized = 'true';
        }
      },
      'o-messestand'
    );
  }
});